import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import useCreateAdditionalGroup, {
  CreateAdditionalGroupProps,
  translatedCreateAdditionalGroupProps,
} from 'modules/additional-groups/hooks/use-create-additional-group';
import useBaseAdditionalGroupsSelect from 'modules/base-additional-groups/hooks/use-base-additional-groups-select';
import useCompaniesSelectData from 'modules/companies/hooks/use-companies-select-data';
import React, {useState} from 'react';
import {useForm} from 'react-hook-form';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreateAdditionalGroup: React.FC = () => {
  const {companyId} = useAccessControls();
  const formContext = useForm<Omit<CreateAdditionalGroupProps, 'additionals'>>({
    defaultValues: {companyId: companyId ?? undefined},
  });
  const {getInput, getSelect} = useFormInputs<CreateAdditionalGroupProps>();
  const {data, isLoading} = useCompaniesSelectData();
  const [baseAdditionalGroupId, setBaseAdditionalGroupId] = useState<string>();
  const baseAdditionalGroupsSelect = useBaseAdditionalGroupsSelect();

  const onFormStateChange = (data: CreateAdditionalGroupProps) => {
    if (
      !data.baseAdditionalGroupId ||
      data.baseAdditionalGroupId === baseAdditionalGroupId
    )
      return;

    setBaseAdditionalGroupId(data.baseAdditionalGroupId);
    const baseAdditionalGroup = baseAdditionalGroupsSelect.data.find(
      (someBaseAdditionalGroup) =>
        someBaseAdditionalGroup.value === data.baseAdditionalGroupId,
    )?.data;

    if (!baseAdditionalGroup) return;

    formContext.setValue('name', baseAdditionalGroup.name);
    formContext.setValue('description', baseAdditionalGroup.description);
  };

  return (
    <Creation<CreateAdditionalGroupProps>
      titleBar={{title: 'Cadastrar Grupo de adicional'}}
      onSubmit={useCreateAdditionalGroup}
      {...{onFormStateChange, formContext}}
      inputs={[
        getSelect({
          name: 'baseAdditionalGroupId',
          data: baseAdditionalGroupsSelect.data,
          isLoading: baseAdditionalGroupsSelect.isLoading,
        }),
        getInput({
          name: 'description',
        }),
        getInput({
          name: 'name',
        }),
        getSelect({
          name: 'companyId',
          data,
          isLoading,
          hidden: () => !!companyId,
        }),
      ]}
      translationKey={translatedCreateAdditionalGroupProps}
    />
  );
};

export default CreateAdditionalGroup;
